<template>
    <div>
        <footer class="footer">
            <div class="f_inner inner">
                
                <img :src="`${$STATIC_URL}/user/img/f_logo.png`" alt="" class="f_logo" >
                <div class="f_info">
                    대표이사 : 제창우 <br>
                    개인정보보호책임자 : 장형준 <br>
                    이용문의 : hello@numberfavored.io <br>
                    주소 : 부산광역시 남구 오륙도로 85, 107 - 3606 <br>
                    사업자등록번호 : 586-01-01650 <br>
                    통신판매업신고번호 : 2022-부산남구-0316
                    <br><br>
                    Copyright {{ year }} Team Favored Co. Ltd.
                </div>
            </div>
        </footer>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const year = ref(new Date().getFullYear());
</script>


<style></style>